var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("path",{"className":"cls-1","d":"M29.28,5.9H2.68a2.37,2.37,0,0,1,0-4.74h26.6a2.37,2.37,0,0,1,0,4.74Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M29.28,18.36H2.68a2.37,2.37,0,0,1,0-4.74h26.6a2.37,2.37,0,0,1,0,4.74Z","key":2}),React.createElement("path",{"className":"cls-1","d":"M29.28,30.81H2.68a2.37,2.37,0,1,1,0-4.73h26.6a2.37,2.37,0,0,1,0,4.73Z","key":3})]);
}

IconMenu.defaultProps = {"id":"圖層_1","data-name":"圖層 1","viewBox":"0 0 32 32"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
